module.exports = __webpack_public_path__ + "static/media/login-web-bg.e181fca6.jpg";